import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React from 'react';
import { Text, ProgressBar } from '@primer/react';
import './index.css.js';

var LTProgressBar = function LTProgressBar(_a) {
  var _b = _a.ariaLabel,
    ariaLabel = _b === void 0 ? undefined : _b,
    _c = _a.animated,
    animated = _c === void 0 ? false : _c,
    _d = _a.extraStyles,
    extraStyles = _d === void 0 ? {} : _d,
    _e = _a.size,
    size = _e === void 0 ? LTProgressBar.Size.DEFAULT : _e,
    _f = _a.segments,
    segments = _f === void 0 ? [] : _f,
    _g = _a.showInlineBar,
    showInlineBar = _g === void 0 ? false : _g,
    _h = _a.textStyles,
    textStyles = _h === void 0 ? {} : _h,
    _j = _a.title,
    title = _j === void 0 ? "" : _j,
    rest = __rest(_a, ["ariaLabel", "animated", "extraStyles", "size", "segments", "showInlineBar", "textStyles", "title"]);
  return /*#__PURE__*/React.createElement("div", null, title && /*#__PURE__*/React.createElement(Text, {
    sx: __assign({}, textStyles)
  }, title), /*#__PURE__*/React.createElement(ProgressBar, __assign({
    animated: animated,
    "aria-label": ariaLabel,
    inline: showInlineBar,
    sx: __assign({}, extraStyles),
    barSize: size
  }, rest), Array.isArray(segments) && (segments === null || segments === void 0 ? void 0 : segments.map(function (segment, index) {
    var _a = segment || {},
      _b = _a.id,
      id = _b === void 0 ? "" : _b,
      _c = _a.progress,
      progress = _c === void 0 ? "" : _c,
      _d = _a.style,
      style = _d === void 0 ? {} : _d;
    return /*#__PURE__*/React.createElement(React.Fragment, null, progress > 0 && /*#__PURE__*/React.createElement(ProgressBar.Item, {
      className: "progress-item",
      key: "".concat(id, "-").concat(index),
      progress: progress,
      sx: __assign({}, style)
    }));
  }))));
};
LTProgressBar.Size = {
  DEFAULT: "default",
  SMALL: "small",
  LARGE: "large"
};

export { LTProgressBar as default };
